<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>تقرير بمراجعة العملاء</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم عرض جميع مراجعات العملاء حسب الفرع والتاريخ
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='alert alert-danger alert-dismissable' v-if='validationErrors'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='col-lg-12' style="margin:0px;padding:0px">
                <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 5px 5px">
                  <label>الفرع</label>
                  <select style="padding:0px" class="form-control"  v-model="branch_id">
                    <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 5px 5px">
                  <tbDate :today='today' :mytitle='fromTitle' v-model= 'date_from' ></tbDate>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 5px 5px">
                  <tbDate :today='today' :mytitle='toTitle' v-model= 'date_to' ></tbDate>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-12' style="padding: 28px 0px 15px 0px; text-align: center;">
                  <button @click='GetData()' type='button'  class='btn btn-outline btn-primary btn-md'>
                    <b>عرض</b>
                  </button>
                </div>
              </div>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>

                    <th style='text-align: center'>م</th>
                    <th style='text-align: center'>المستخدم</th>
                    <th style='text-align: center'>العدد</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='(record,index) in records' :key='record.id'>

                    <td align='center'>{{index +1}}</td>
                    <td align='center'>{{record.name}}</td>
                    <td align='center'>{{record.count}}</td>
                  </tr>
                </tbody>
              </table>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'return_purchase_masters',
  data () {
    return {
      today: true,
      fromTitle: 'من',
      toTitle: 'إلى',
      date_from: '',
      date_to: '',
      branches: {},
      branch_id: '',
      validationErrors: '',
      records: {},
      errorShow: false,
      isLoadingData: false
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branch_id = localStorage.getItem('BrancheID')
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      this.validationErrors = ''
      axios.post(this.$apiURL + 'get-customer-review', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        date_from: this.date_from,
        date_to: this.date_to
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reports/CustomrReviewRep.vue